const GET_COMPLIANCE_REPORT_GRID_DATA = 'GET_COMPLIANCE_REPORT_GRID_DATA';
const SET_COMPLIANCE_REPORT_GRID_DATA = 'SET_COMPLIANCE_REPORT_GRID_DATA';

const GET_COMPLIANCE_REPORT_TABLE_EXCEL = 'GET_COMPLIANCE_REPORT_TABLE_EXCEL';
const SET_COMPLIANCE_REPORT_TABLE_EXCEL = 'SET_COMPLIANCE_REPORT_TABLE_EXCEL';

const SET_COMPLIANCE_REPORT_FILTER_DATA = 'SET_COMPLIANCE_REPORT_FILTER_DATA';

const GET_COMPLIANCE_MODIFICATION_REPORT = 'GET_COMPLIANCE_MODIFICATION_REPORT';
const SET_COMPLIANCE_MODIFICATION_REPORT = 'SET_COMPLIANCE_MODIFICATION_REPORT';

const GET_APPROVER_UPDATES_GRID_DATA = 'GET_APPROVER_UPDATES_GRID_DATA';
const SET_APPROVER_UPDATES_GRID_DATA = 'SET_APPROVER_UPDATES_GRID_DATA';

const GET_COMPLIANCE_AUDIT_EXPORT_EXCEL = 'GET_COMPLIANCE_AUDIT_EXPORT_EXCEL';
const SET_COMPLIANCE_AUDIT_EXPORT_EXCEL = 'SET_COMPLIANCE_AUDIT_EXPORT_EXCEL'

export {
    GET_COMPLIANCE_REPORT_GRID_DATA,
    SET_COMPLIANCE_REPORT_GRID_DATA,
    GET_COMPLIANCE_REPORT_TABLE_EXCEL,
    SET_COMPLIANCE_REPORT_TABLE_EXCEL,
    SET_COMPLIANCE_REPORT_FILTER_DATA,
    GET_COMPLIANCE_MODIFICATION_REPORT,
    SET_COMPLIANCE_MODIFICATION_REPORT,
    GET_APPROVER_UPDATES_GRID_DATA,
    SET_APPROVER_UPDATES_GRID_DATA,
    GET_COMPLIANCE_AUDIT_EXPORT_EXCEL,
    SET_COMPLIANCE_AUDIT_EXPORT_EXCEL
}